<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">{{routeName}}</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/corporations" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createCorporation">
                <div class="row justify-content-md-center">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-md-3">
                        <fg-input type="text"
                                  v-model="corporation.name"
                                  label="Name"
                                  placeholder="Enter name"
                                  v-validate="rules.name"
                                  data-vv-name="name"
                                  cus-name="name"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-3">
                        <fg-input type="text"
                                  v-model="corporation.accountLimit"
                                  label="Account Limit"
                                  placeholder="Enter Account Limit"
                                  v-validate="rules.accountLimit"
                                  data-vv-name="account limit"
                                  cus-name="account limit"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-3">
                        <fg-input type="text"
                                  v-model="corporation.domain"
                                  label="Domain"
                                  placeholder="Enter Domain"
                                  v-validate="rules.domain"
                                  data-vv-name="domain"
                                  cus-name="domain"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-3">
                        <fg-input type="text"
                                  v-model="corporation.invitation_code"
                                  label="Type"
                                  placeholder="Enter Type"
                                  v-validate="rules.invitation_code"
                                  data-vv-name="invitation_code"
                                  cus-name="invitation_code"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-3" v-if="status.length">
                        <fg-select
                          v-model="corporation.active"
                          label="Status"
                          v-validate="rules.active"
                          data-vv-name="active"
                          cus-name="active"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="status"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>

                      <div class="col-md-3">
                        <fg-input type="text"
                                  v-model="corporation.contactFirstName"
                                  label="Contact First Name"
                                  placeholder="Enter Contact First Name"
                                  v-validate="rules.contactFirstName"
                                  data-vv-name="contact first name"
                                  cus-name="contact first name"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-3">
                        <fg-input type="text"
                                  v-model="corporation.contactLastName"
                                  label="Contact Last Name"
                                  placeholder="Enter Contact Last Name"
                                  v-validate="rules.contactLastName"
                                  data-vv-name="contact last name"
                                  cus-name="contact last name"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-3">
                        <fg-input type="text"
                                  v-model="corporation.contactEmail"
                                  label="Contact Email"
                                  placeholder="Enter Contact Email"
                                  v-validate="rules.contactEmail"
                                  data-vv-name="contact email"
                                  cus-name="contact email"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-3">
                        <fg-input type="text"
                                  v-model="corporation.contactPhone"
                                  label="Contact Phone"
                                  placeholder="Enter Contact Phone"
                                  v-validate="rules.contactPhone"
                                  data-vv-name="contact phone"
                                  cus-name="contact phone"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>

                      <div class="col-md-3">
                        <fg-input type="text"
                                  v-model="corporation.contactAddress"
                                  label="Contact Address"
                                  placeholder="Enter Contact Address"
                                  v-validate="rules.contactAddress"
                                  data-vv-name="contact address"
                                  cus-name="contact address"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-3">
                        <fg-input type="text"
                                  v-model="corporation.contactCity"
                                  label="Contact City"
                                  placeholder="Enter Contact City"
                                  v-validate="rules.contactCity"
                                  data-vv-name="contact city"
                                  cus-name="contact city"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-3">
                        <fg-input type="text"
                                  v-model="corporation.contactState"
                                  label="Contact State"
                                  placeholder="Enter Contact State"
                                  v-validate="rules.contactState"
                                  data-vv-name="contact state"
                                  cus-name="contact state"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-3">
                        <fg-input type="text"
                                  v-model="corporation.contactZip"
                                  label="Contact Zip"
                                  placeholder="Enter Contact Zip"
                                  v-validate="rules.contactZip"
                                  data-vv-name="contact zip"
                                  cus-name="contact zip"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>

                      <div class="col-12">
                        <fg-text-area
                          rows="2"
                          v-model="corporation.description"
                          label="Description"
                          placeholder="Enter Description"
                          v-validate="rules.description"
                          data-vv-name="description"
                          cus-name="description"
                          :has-errors="errors"
                          :is-fields="fields"
                        >
                        </fg-text-area>
                      </div>

<!--                      <div class="col-12">-->
<!--                        <fg-text-area-->
<!--                          rows="2"-->
<!--                          v-model="corporation.welcomeMessage"-->
<!--                          label="Welcome Message"-->
<!--                          placeholder="Enter welcome message"-->
<!--                          v-validate="rules.welcomeMessage"-->
<!--                          data-vv-name="welcome message"-->
<!--                          cus-name="welcome message"-->
<!--                          :has-errors="errors"-->
<!--                          :is-fields="fields"-->
<!--                        >-->
<!--                        </fg-text-area>-->
<!--                      </div>-->

<!--                      <div class="col-12">-->
<!--                        <fg-text-area-->
<!--                          rows="2"-->
<!--                          v-model="corporation.button_label_01"-->
<!--                          label="Button Label"-->
<!--                          placeholder="Enter Button Label"-->
<!--                          v-validate="rules.button_label_01"-->
<!--                          data-vv-name="Button Label"-->
<!--                          cus-name="Button Label"-->
<!--                          :has-errors="errors"-->
<!--                          :is-fields="fields"-->
<!--                        >-->
<!--                        </fg-text-area>-->
<!--                      </div>-->
<!--                      <div class="col-12">-->
<!--                        <fg-text-area-->
<!--                          rows="2"-->
<!--                          v-model="corporation.signupGiftDesc"-->
<!--                          label="Gift Redeem Package Description"-->
<!--                          placeholder="Enter Package Description"-->
<!--                        >-->
<!--                        </fg-text-area>-->
<!--                      </div>-->

                      <div class="col-md-6 col-xs-12">
                        <fg-image type="file"
                                  v-on:file="updateLargeImg"
                                  v-model="corporation.largeImage"
                                  label="Large Image"
                                  v-validate="rules.largeImage"
                                  data-vv-name="large image"
                                  cus-name="large image"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-image>
                      </div>
                      <div class="col-md-6 col-xs-12">
                        <fg-image type="file"
                                  v-on:file="updateSmallImg"
                                  v-model="corporation.smallImage"
                                  label="Small Image"
                                  v-validate="rules.smallImage"
                                  data-vv-name="small image"
                                  cus-name="small image"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-image>
                      </div>
                      <br/>
                      <legend>Community Page Setting</legend><hr>
                      <br/>
                      <div class="col-md-3" v-if="corpStatus.length">
                        <fg-select
                          v-model="corporation.enableCorporatePage"
                          label="Page Status"
                          :is-fields="fields"
                          :list="corpStatus"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                      <div class="col-md-3" v-if="spotlightSection.length">
                        <fg-select
                          v-model="corporation.showSpotlightSection"
                          label="Spotlight Status"
                          :is-fields="fields"
                          :list="spotlightSection"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                      <div class="col-md-3" v-if="pinnedSection.length">
                        <fg-select
                          v-model="corporation.showPinnedMessages"
                          label="Pinned Msgs Status"
                          :is-fields="fields"
                          :list="pinnedSection"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                      <div class="col-md-3" v-if="defaultCorpTabStatus.length">
                        <fg-select
                          v-model="corporation.defaultCorpTab"
                          label="Default Tab"
                          :is-fields="fields"
                          :list="defaultCorpTabStatus"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                      <div class="col-md-12">
                        <fg-input type="text"
                                  v-model="corporation.spotlightPic"
                                  label="Spotlight Image URL"
                                  placeholder="Enter Spotlight Image"
                        >
                        </fg-input>
                      </div>
                      <div class="col-md-12">
                        <fg-text-area type="text"
                                      v-model="corporation.pageWelcomeMessage"
                                      label="Corporate Page Welcome Message"
                                      placeholder="Enter Message"
                                      data-vv-name="pageWelcomeMessage"
                                      cus-name="pageWelcomeMessage"
                        >
                        </fg-text-area>
                      </div>
                      <div class="col-md-12">
                        <fg-text-area type="text"
                                      v-model="corporation.spotlightQuote"
                                      label="Enter Spotlight Quote"
                                      placeholder="Enter Spotlight Quote"
                                      data-vv-name="Quote"
                                      cus-name="Quote"
                        >
                        </fg-text-area>
                      </div>
                      <div class="col-md-12">
                        <fg-text-area type="text"
                                      v-model="corporation.spotlightPara1"
                                      label="Enter Spotlight Paragraph 1"
                                      placeholder="Enter Spotlight Paragraph 1"
                                      data-vv-name="paragraph4"
                                      cus-name="paragraph4"
                        >
                        </fg-text-area>
                      </div>
                      <div class="col-md-12">
                        <fg-text-area type="text"
                                      v-model="corporation.spotlightPara2"
                                      label="Enter Spotlight Paragraph 2"
                                      placeholder="Enter Spotlight Paragraph 2"
                                      data-vv-name="paragraph4"
                                      cus-name="paragraph4"
                        >
                        </fg-text-area>
                      </div>
                      <div class="col-md-12">
                        <fg-text-area type="text"
                                      v-model="corporation.spotlightPara3"
                                      label="Enter Spotlight Paragraph 3"
                                      placeholder="Enter Spotlight Paragraph 3"
                                      data-vv-name="paragraph4"
                                      cus-name="paragraph4"
                        >
                        </fg-text-area>
                      </div>
                      <div class="col-md-12">
                        <fg-text-area type="text"
                                      v-model="corporation.privateEventHeading"
                                      label="Private Events Heading"
                                      placeholder="Heading"
                                      data-vv-name="privateEventHeading"
                                      cus-name="privateEventHeading"
                        >
                        </fg-text-area>
                      </div>
                      <div class="col-md-12">
                        <fg-text-area type="text"
                                      v-model="corporation.toneEventHeading"
                                      label="TONE Events Heading"
                                      placeholder="Heading"
                                      data-vv-name="toneEventHeading"
                                      cus-name="toneEventHeading"
                        >
                        </fg-text-area>
                      </div>
                      <div class="col-md-12">
                        <fg-text-area type="text"
                                      v-model="corporation.archiveEventHeading"
                                      label="Archive Section Heading"
                                      placeholder="Enter Heading"
                                      data-vv-name="archiveEventHeading"
                                      cus-name="archiveEventHeading"
                        >
                        </fg-text-area>
                      </div>
                      <div class="col-md-12">
                        <fg-text-area type="text"
                                      v-model="corporation.pinnedMessageHeading"
                                      label="Pinned Message Heading"
                                      placeholder="Enter Heading"
                                      data-vv-name="pinnedMessageHeading"
                                      cus-name="pinnedMessageHeading"
                        >
                        </fg-text-area>
                      </div>
                      <div class="col-md-12">
                        <fg-text-area type="text"
                                      v-model="corporation.playlistHeading"
                                      label="Playlist Section Heading"
                                      placeholder="Enter Heading"
                                      data-vv-name="playlistHeading"
                                      cus-name="playlistHeading"
                        >
                        </fg-text-area>
                      </div>
                      <br/>
                      <legend>Profile/Signup Page Settings</legend><hr><br>
                      <div class="col-md-4" v-if="mobileFlags.length">
                        <fg-select
                          v-model="corporation.phoneFlag"
                          label="Mobile Field Visibility"
                          :is-fields="fields"
                          :list="mobileFlags"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                      <div class="col-md-4" v-if="dobFlags.length">
                        <fg-select
                          v-model="corporation.dobFlag"
                          label="DOB Field Visibility"
                          :is-fields="fields"
                          :list="dobFlags"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                      <div class="col-md-4" v-if="shoeMotifFlags.length">
                        <fg-select
                          v-model="corporation.showShoeMotif"
                          label="Shoe-motif Flag"
                          :is-fields="fields"
                          :list="shoeMotifFlags"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                      <br/>
                      <legend>Corporation Private Video Settings</legend><hr><br>
                      <div class="col-md-12">
                        <fg-input type="text"
                                  v-model="corporation.videoTabHeading"
                                  label="Private Video Section Heading"
                                  placeholder="Enter Message"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-12">
                        <fg-input type="text"
                                  v-model="corporation.csvShowVideoCodes"
                                  label="Video Codes (To show)"
                                  placeholder="Enter Video Codes (comma separated)"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-12">
                        <fg-input type="text"
                                  v-model="corporation.csvHiddenVideoCodes"
                                  label="Video Codes (To hide)"
                                  placeholder="Enter Video Codes (comma separated)"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <legend>Custom Banner Status</legend><br>
                      <div class="col-md-12" v-if="giftIconStatus.length">
                        <fg-select
                          v-model="corporation.giftIconState"
                          label="Gifting Status"
                          :is-fields="fields"
                          :list="giftIconStatus"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                        <div class="col-md-8" v-if="showCustomMessageFlag">
                          <fg-input type="text"
                                    v-model="corporation.giftIconMessage"
                                    label="Custom Message"
                                    placeholder="Enter Custom Message"
                                    :is-fields="fields">
                          </fg-input>
                        </div>
                        <div class="col-md-4" v-if="showCustomMessageFlag">
                          <fg-input type="text"
                                    v-model="corporation.giftIconUrl"
                                    label="Enter URL (Optional)"
                                    placeholder="Enter Url"
                                    :is-fields="fields">
                          </fg-input>
                        </div>
                      <legend>Event Banner Status</legend><br>
                      <div class="col-md-12" v-if="eventBannerStatus.length">
                        <fg-select
                          v-model="corporation.bnrLinkState"
                          label="Event Banner Behavior"
                          :is-fields="fields"
                          :list="eventBannerStatus"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                      <div class="col-md-6" v-if="showCustomBannerFlag">
                        <label>Start Date</label>
                        <datetime v-model="startDate"
                                  input-class="form-control"
                                  placeholder="Choose a Date"
                                  type="datetime"
                                  :min-datetime="startDate"
                                  input-format="DD-MM-YYYY HH:mm"
                                  auto-continue required>

                        </datetime>
                      </div>
                      <div class="col-md-6" v-if="showCustomBannerFlag">
                        <label>End Date</label>
                        <datetime v-model="endDate"
                                  input-class="form-control"
                                  placeholder="Choose a Date"
                                  type="datetime"
                                  input-format="DD-MM-YYYY HH:mm"
                                  :min-datetime="startDate"
                                  auto-continue required>

                        </datetime>
                      </div>
                      <div class="col-md-8" v-if="corporation.bnrLinkState === '3'">
                        <fg-input type="text"
                                  v-model="corporation.bnrCustomMsg"
                                  label="Custom Banner"
                                  placeholder="Enter Custom Banner"
                                  :is-fields="fields" required>
                        </fg-input>
                      </div>
                      <div class="col-md-4" v-if="corporation.bnrLinkState === '3'">
                        <fg-input type="text"
                                  v-model="corporation.bnrCustomMsgUrl"
                                  label="Enter URL"
                                  placeholder="Enter Url"
                                  :is-fields="fields" required>
                        </fg-input>
                      </div>
<!--                      <br/>-->
<!--                      <legend>Manage Email Flow</legend><hr>-->
<!--                      <br/>-->
<!--                      <div class="col-md-4">-->
<!--                        <div class="checkbox">-->
<!--                          <label >-->
<!--                            <input type="checkbox" class="form-input" v-model="allowEmail"> Send Email (On Enabling Page)-->
<!--                          </label>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="col-md-4">-->
<!--                        <div class="checkbox">-->
<!--                          <label >-->
<!--                            <input type="checkbox" class="form-input" v-model="allowCoachingSection"> Allow Coaching Section-->
<!--                          </label>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="col-md-4">-->
<!--                        <div class="checkbox">-->
<!--                          <label >-->
<!--                            <input type="checkbox" class="form-input" v-model="allowLiveSection">  Allow Live Event Section-->
<!--                          </label>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="col-md-4">-->
<!--                        <div class="checkbox">-->
<!--                          <label >-->
<!--                            <input type="checkbox" class="form-input" v-model="allowCustonSection"> Allow Custom Content Section-->
<!--                          </label>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="col-md-4">-->
<!--                        <div class="checkbox">-->
<!--                          <label >-->
<!--                            <input type="checkbox" class="form-input" v-model="allowVideoShareSection"> Allow Share Video Section-->
<!--                          </label>-->
<!--                        </div>-->
<!--                      </div>-->
                    </div>
                  </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Create Corporation
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreateCorporation',
        data () {
          let dateTime = new Date();
        return {
          startDate: dateTime.toISOString(),
          endDate: new Date(dateTime.setHours(dateTime.getHours() + 1)).toISOString(),
            largeNewImage: [],
            smallNewImage: [],
            corporation: {
                name: "",
                description: null,
                accountLimit: 0,
                domain: null,
                invitation_code: null,
                contactAddress: null,
                contactCity: null,
                contactEmail: null,
                contactFirstName: null,
                contactLastName: null,
                contactPhone: null,
                contactState: null,
                contactZip: null,
                largeImage: null,
                smallImage: null,
                active: null,
                welcomeMessage: null,
                button_label_01: null,
                spotlightPic: '',
                spotlightPara1: '',
                spotlightPara2: '',
                spotlightPara3: '',
                spotlightQuote: '',
                pageWelcomeMessage: '',
                enableCorporatePage: 0,
                showPinnedMessages: 0,
               showSpotlightSection: 0,
                privateEventHeading: '',
                toneEventHeading: '',
                archiveEventHeading: '',
                playlistHeading: '',
                pinnedMessageHeading: '',
                dobFlag: 1,
                phoneFlag: 1,
                csvHiddenVideoCodes: '',
                csvShowVideoCodes: '',
                videoTabHeading: '',
                giftIconState: 1,
                giftIconMessage: '',
                giftIconUrl: '',
                bnrLinkState: 1,
                bnrPvtStartTime: '',
                bnrPvtEndTime: '',
                bnrCustomMsg: '',
                bnrCustomMsgUrl: '',
                cceSendEmail: 0,
                cceLiveEventParaAccess: 0,
                cceCustomContentAccess: 0,
                cceCommCoachingAccess: 0,
                cceShareVideoAccess: 0,
                defaultCorpTab: 1,
                showShoeMotif: 1,
                signupGiftDesc: ''
            },
            status: [{name:'Select Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
            corpStatus: [{name:'Select Page Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
            spotlightSection: [{name:'Select Spotlight Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
            pinnedSection: [{name:'Select Pinned Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
            mobileFlags: [{id:1, name:'Show on Profile & Signup'}, {id:2, name:'Show on Profile'}, {id:3, name:'Show on Signup'}, {id:4, name:'Hide on Profile & Signup'}],
            dobFlags: [{id:1, name:'Show on Profile'}, {id:2, name:'Hide on Profile'}],
            giftIconStatus: [{id:1, name:'Gift of TONE Visible'}, {id:2, name:'Gift of TONE Invisible Without Custom Message'}, {id:3, name:'Gift of TONE Invisible With Custom Message'}],
            eventBannerStatus: [{id:1, name:'Link to Public Event'}, {id:2, name:'Link to Private Event'}, {id:3, name:'Custom Link'}],
          defaultCorpTabStatus: [{id:1, name:'Career Coaching'}, {id:2, name:'Community'}, {id:3, name:'Playlists'}, {id:4, name:'Videos'}],
          shoeMotifFlags: [{id:1, name:'Show Shoe Motif'}, {id:2, name:'Hide Shoe Motif'}],
          showCustomMessageFlag: false,
            showCustomBannerFlag: false,
            allowEmail: false,
            allowLiveSection: false,
            allowCustonSection: false,
            allowVideoShareSection: false,
            allowCoachingSection: false,
            rules: {
                name : {required: true},
                description : {required: false},
                accountLimit : {required: true, numeric:true},
                domain : {required: false},
                invitation_code : {required: true, numeric:true},
                contactAddress : {required: false},
                contactCity : {required: false},
                contactEmail : {required: false, email:true},
                contactFirstName : {required: false},
                contactLastName : {required: false},
                contactPhone : {required: false, numeric:true},
                contactState : {required: false},
                contactZip : {required: false},
                largeImage : {required: false},
                smallImage : {required: false},
                active : {required: true},
                welcomeMessage : {required: true},
                button_label_01 : {required: true}
            },
        }
    },
    methods: {
        createCorporation () {
          let startDate = new Date(this.startDate).getTime();
          let endDate = new Date(this.endDate).getTime();
          if (this.corporation.bnrLinkState > 1) {
            this.corporation.bnrPvtStartTime =  moment(startDate).format('MM/DD/YYYY H:mm:ss');
            this.corporation.bnrPvtEndTime =  moment(endDate).format('MM/DD/YYYY H:mm:ss');
          } else {
            this.corporation.bnrPvtStartTime =  null;
            this.corporation.bnrPvtEndTime =  null;
          }
          this.corporation.cceSendEmail = this.allowEmail ? 1 : 0
          this.corporation.cceLiveEventParaAccess = this.allowLiveSection ? 1 : 0
          this.corporation.cceCommCoachingAccess = this.allowCoachingSection ? 1 : 0
          this.corporation.cceCustomContentAccess = this.allowCustonSection ? 1 : 0
          this.corporation.cceShareVideoAccess = this.allowVideoShareSection ? 1 : 0
            this.$validator.validateAll().then((result) => {
                if(result){
                    console.log("this.corporation : ", this.corporation);
                    let createExpert = () => {
                        this.$store.dispatch('ADD_CORPORATION', {
                            corporation: this.corporation,
                            largeImage: this.largeNewImage[0],
                            smallImage: this.smallNewImage[0]
                        })
                                .then((res) => {
                                    console.log("ADD_CORPORATION res : ", res);
                                    if(res) this.showPopup('Success!', 'Corporation is successfully created', 'success', ()=> this.$router.push('/admin/corporations'))
                                    else this.showPopup('Error!', 'Unable to process.', 'error')
                                })
                                .catch(err => {
                                    this.showPopup('Error!', 'Corporation name is already created.', 'error')
                                    console.log("ADD_CORPORATION API error : ", err);
                                })
                    }
                    createExpert();
                }

            })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        },
        capitalizeFirstLetter (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },
        updateLargeImg(data){
            this.corporation.largeImage = data.path;
            this.largeNewImage = data.value;
            console.log("updateLargeImg data : ", data);
        },
        updateSmallImg(data){
            this.corporation.smallImage = data.path;
            this.smallNewImage = data.value;
            console.log("updateSmallImg data : ", data);
        },
    },
    watch: {
          'corporation.giftIconState' (to, from) {
            let self = this
            if (self.corporation.giftIconState === '3') {
              self.showCustomMessageFlag = true
              self.corporation.giftIconMessage = '',
                self.corporation.giftIconUrl = ''
            } else {
              self.showCustomMessageFlag = false
              self.corporation.giftIconMessage = '',
                self.corporation.giftIconUrl = ''
            }
          },
      'corporation.bnrLinkState' (to, from) {
        let self = this
        if (self.corporation.bnrLinkState >  1) {
          self.showCustomBannerFlag = true
          self.corporation.bnrCustomMsg = '',
          self.corporation.bnrCustomMsgUrl = ''
        } else {
          self.showCustomBannerFlag = false
          self.corporation.bnrCustomMsg = '',
          self.corporation.bnrCustomMsgUrl = ''
        }
      }
    },
    computed:{
        routeName () {
            const {name} = this.$route;
            return this.capitalizeFirstLetter(name);
        }
    }

    }
</script>
<style scoped>
  legend {
    color: deepskyblue;
    text-align: center;
    padding: 25px;
    /* text-underline-position: under; */
  }
</style>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Corporations/CreateCorporation.vue